import {createTheme} from "@material-ui/core/styles";

export const theme = createTheme({
    typography: {
        fontFamily: ["Montserrat"].join(","),
    },
    palette: {
        primary: {main: "rgb(255, 218, 51)"},
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 700,
            md: 900,
            lg: 1400,
            xl: 1800,
        },
    },
    shape: {
        borderRadius: "1rem",
    },
});
